const getColorValue = (v) => (v && v.length < 7
  ? v
    .split('')
    .reduce((hex, c) => {
      if (c === '#') {
        return [...hex, c];
      }
      return [...hex, c, c];
    }, [])
    .join('')
  : v);

export default getColorValue;
